import React from 'react';

const ExternalVRTour = ({ tourUrl }) => {
  // Append parameters to autoplay, loop, and minimize UI controls for a cleaner background look.
  const backgroundTourUrl = `${tourUrl}?autoplay=true&loop=true&gyro=false&vr=false&fullscreen=false`;

  return (
    <div style={{ width: '100%', height: '100vh', border: 'none' }}>
      <iframe
        src={backgroundTourUrl} // Use the modified URL with autoplay and loop
        title="External VR Tour"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        allowFullScreen
        allow="autoplay; fullscreen; xr-spatial-tracking;" // Added autoplay, fullscreen, and xr-spatial-tracking for VR experiences
        sandbox="allow-scripts allow-same-origin allow-presentation" // Added allow-presentation for potential fullscreen/VR modes
      />
    </div>
  );
};

export default ExternalVRTour;
